// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback } from 'react'
import classNames from 'classnames'
import RadioButton from './radio-button/RadioButton'
import './radioButtonsGroup.scss'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const RadioButtonsGroup = memo(({ optionsList = [], onChangeButtonGroup, setSelectedOption, className }) => {
  const onToggleSelectMode = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setSelectedOption((prev) => prev.map((t) => ({ ...t, isChecked: t.value === value })))
      onChangeButtonGroup?.()
    },
    [onChangeButtonGroup, setSelectedOption],
  )

  return (
    <div className={classNames('radio-buttons-group-container', [className])}>
      {/*
       // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
      {optionsList?.map(({ value, isHidden, isChecked }) => (
        <RadioButton
          key={value}
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          onToggleSelectMode={onToggleSelectMode}
          isChecked={isChecked}
          value={value}
          isHidden={isHidden}
        />
      ))}
    </div>
  )
})

export default RadioButtonsGroup
